var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#FF3B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.006 391.5C289.985 420.605 76.5653 230.858 121.006 184C165.446 137.143 173.499 125.831 187.502 132.5C195.334 136.229 211.139 167.535 223.55 194.405C229.968 208.302 202.777 212.746 201.506 228C200.506 240 268.006 300 279.506 308.5C284.482 312.179 290.676 307.523 296.1 301.058C304.692 290.819 318.6 285.275 330.631 291.098C352.446 301.655 383.531 317.864 388.006 326.5C395.002 340 362.026 362.395 326.006 391.5Z",
    stroke: "white",
    strokeWidth: 24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.41e04616621591537cf2db86a1a2dcb4.svg";
export { ForwardRef as ReactComponent };